import {
  ERROR_FETCH_RECOARDS,
  FETCH_RECOARS,
  SEARCH_RECOAR,
} from '../actions/types';

const initialState = {
  data: [],
  pageNumber: 1,
  pageSize: 0,
  totalElment: 0,
  total_pages: 0,
  loading: true,
};
export default function (state = initialState, action) {
  const { type, payload } = action;
  // console.log(type);
  // console.log('state', payload);
  switch (type) {
    case FETCH_RECOARS:
    case SEARCH_RECOAR:
      return {
        ...state,
        data: payload.data,
        pageNumber: payload.pageNumber,
        pageSize: payload.pageSize,
        totalElment: payload.totalElment,
        total_pages: payload.total_pages,
        loading: false,
      };
    case ERROR_FETCH_RECOARDS:
      return {
        ...state,
        data: [],
        pageNumber: 1,
        pageSize: 0,
        totalElment: 0,
        total_pages: 0,
        loading: true,
      };
    default:
      return state;
  }
}
